<template>
  <div>
    <a-divider />
    <a-card :bordered="false">
      <a-breadcrumb style="margin-bottom: 10px" separator=">">
        <a-breadcrumb-item
          ><router-link to="/course"
            >课程列表</router-link
          ></a-breadcrumb-item
        >
        <a-breadcrumb-item>浏览课程</a-breadcrumb-item>
      </a-breadcrumb>
      <a-row type="flex" justify="space-between" :gutter="_isMobile()?10:40">
        <a-col :flex="_isMobile()?1:'450px'" :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
          <a-skeleton v-if="!info.courseCover"/>
          <img class="cover" v-if="info.courseCover" :src="info.courseCover_url" alt="">
        </a-col>
        <a-col :flex="_isMobile()?1:'auto'" :xs="24" :sm="24" :md="14" :lg="14" :xl="14">
          <h3>{{info.courseName}}</h3>
          <p>{{info.courseDesc}}</p>
          <p>
            <span class="gray">选择数量：</span>
            <a-input-number size="small" :min="1" :max="999" :default-value="1" v-model="appoInfo.num"/>
            <a-divider type="vertical"/>
            <span>￥{{(info.coursePrice/100*appoInfo.num).toFixed(2)}}</span>
          </p>
          <a-button size="large" type="primary" @click="appoVisible=true"> 我要学习 </a-button>
          <br><br>
          <p  class="gray"><pre>{{info.courseComment}}</pre></p>
        </a-col>
      </a-row>
    </a-card>
    <a-divider />
    <a-card :bordered="false">
        <h3 class="title">章节</h3>
        <a-list :dataSource="courseUnitDataSource">
            <a-list-item slot="renderItem" slot-scope="item">
                <h3 class="title">{{ item.unitName }}</h3>
                <a-button slot="actions" size="small" @click="toCourse(item)"
                    >点击进入学习<a-icon type="right"/></a-button
                  >
            </a-list-item>
          </a-list>
    </a-card>
    <a-modal
      :visible="appoVisible"
      :maskClosable="false"
      title="我要学习"
      :destroyOnClose="true"
      @cancel="appoVisible=false"
      @ok="appointment"
    >
      <a-form>
        <a-form-item label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="appoInfo.realname" placeholder="请输入真实姓名/全名"></a-input>
        </a-form-item>
         <a-form-item label="手机号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="appoInfo.phone" placeholder="请输入联系手机号码"></a-input>
        </a-form-item>
         <a-form-item label="单位名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea v-model="appoInfo.unit" placeholder="请输入所在单位的名称"></a-textarea>
        </a-form-item>
         <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea :auto-size="{ minRows: 2, maxRows: 10 }" v-model="appoInfo.comment" placeholder="请输入品牌名称、所在地市，以及留言或需要备注的信息。"></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
    <unitView-modal ref="unitViewModal" />
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG,ACCESS_TOKEN } from "@/store/mutation-types";
import config from '../theme.config'
import {getAction, postAction} from "@/api/manage"
import {mixinDevice} from '@/utils/mixin.js'
import UnitViewModal from '@/components/course/UnitViewModal'
export default {
  mixins: [mixinDevice],
  components:{
    UnitViewModal
  },
  data(){
    return{
      id:'',
      courseUnitDataSource:[
        {id:'123', unitName: '章节'}
      ],
      info: {},
      appoVisible: false,
      appoInfo: {
        num: 1,
        realname: '',
        phone: '',
        wechat: '',
        address: '',
        major: "",
        unit: '',
        comment: '',
        appointmentType: 3,
        relId: ''
      },
      appoSuccess: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      token: '',
      tenantConfig:{}
    }
  },
  created() {
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    this.id = this.$route.query.id
    this.appoInfo.relId = this.id
    this.getInfo()
    if (Vue.ls.get(ACCESS_TOKEN)){
      this.token = Vue.ls.get(ACCESS_TOKEN)
    }
  },
   mounted(){
    window.document.title = this.tenantConfig.brandName + " " +  "课程详情"
  },
  methods: {
    getInfo(){
      getAction("/teaching/teachingCourse/get",{id: this.id}).then(res=>{
        if(res.success){
          this.info = res.result
          this.getList()
        }
      })
    },
    getList(){
      getAction("/teaching/teachingCourseUnit/showCourseUnit",{courseId: this.id}).then(res=>{
        if(res.success){
          this.courseUnitDataSource = res.result
        }
      })
    },
    appointment(){
      console.log(this.appoInfo);
      if(this.appoSuccess){
        this.$message.info("已经预约了")
        return
      }
      if(!this.appoInfo.realname || !this.appoInfo.phone){
        this.$message.info("请填写完整")
        return
      }
      postAction("/teaching/teachingAppointment/add", this.appoInfo).then(res=>{
        if(res.success){
          this.$message.success("预定成功")
          this.appoSuccess = true
          this.appoVisible=false
        }
      })
    },
    toCourse(unit){
      //window.location.href = config.adminUrl + `/teaching/myCourse/courseUnitCard?id=${unit.courseId}&token=${this.token}`
      this.$refs.unitViewModal.view(unit)
    }
  },
};
</script>

<style lang="less" scoped>
.gray{
    color: gray;
}
.cover{
  width: 100%;
}
.detail{
  overflow-x: scroll;
}
.title{
  font-size: 15px;
  line-height: 22px;
  margin-bottom: 0;
  overflow: hidden;
}
</style>